export const EPIC_END = '@@redux-observable/EPIC_END';
